import React from 'react';

const UserAgreement = () => (
  <div>
    <h1>User agreement!</h1>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum tempore dolor inventore at omnis voluptas pariatur doloribus cumque fuga, illum quaerat molestias impedit hic! Vero ipsum, mollitia voluptatem laudantium nostrum saepe. Distinctio dicta, alias optio tenetur deserunt facilis unde veniam impedit a delectus quas quod laborum quam, nemo hic aut autem. A reiciendis voluptatibus esse ut, quisquam vero consequatur pariatur?</p>
  </div>
);

export default UserAgreement;